import { createContext, useContext } from 'react';
import type { SystemPreferences } from '../../../services/SystemPreferencesAPI';

interface PreferencesContextType {
  preferences: SystemPreferences | null;
  updatePreference: <K extends keyof SystemPreferences>(key: K, value: SystemPreferences[K]) => void;
}

export const PreferencesContext = createContext<PreferencesContextType | null>(null);

export const usePreferences = () => {
  const context = useContext(PreferencesContext);
  if (!context) {
    throw new Error('usePreferences must be used within PreferencesContext.Provider');
  }
  return context;
};
